import React from 'react';
import { HdButton } from '../../../components';
import useAnalyticsTracker from '../../../analytics/hooks/useAnalyticsTracker';
import { TRACKER_VERSION_UPDATE_REFRESH } from '../../tracking/dashboardBannerTracking';

export default function VersionUpdateBannerMessage() {
  const analyticsTracker = useAnalyticsTracker();

  const refresh = () => {
    analyticsTracker.eventTrack({
      action: TRACKER_VERSION_UPDATE_REFRESH
    });
    window.location.reload();
  };

  return (
    <>
      Hevo is ready with a new version, tap refresh to update now.
      <HdButton
        dataId='version-update-banner-message'
        size='sm'
        variation='outline'
        palette='light'
        inlineText
        className='ml-2'
        onClick={refresh}
      >
        Refresh
      </HdButton>
    </>
  );
}
